export const max = <T>(values: T[], comparator: (value: T) => number): T => {
  if (values.length === 0) {
    throw new Error('Cannot find max of empty array');
  }
  if (values.length === 1) {
    return values[0];
  }

  let maxValue = values[0];
  let maxComparison = comparator(maxValue);

  for (let i = 1; i < values.length; i++) {
    const currentComparison = comparator(values[i]);
    if (currentComparison > maxComparison) {
      maxValue = values[i];
      maxComparison = currentComparison;
    }
  }

  return maxValue;
};
